import fp from 'lodash/fp'

export const getOptionLabel = fp.prop('displayName')
export const getOptionValue = fp.prop('displayName')

export const convertForm = ({ bankAccountName, ...form }) => {
  form.bankAccountName = bankAccountName.displayName
  return form
}
